<template>
    <div style="
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        background-color: white;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        padding: 100px 20px 20px;
    ">
            <span style="min-width: 35px; max-width: 35px; width: 35px; height: 35px; display: flex; align-items: center; justify-content: center; color: #212B36; background-color: #F2F2F2; border-radius: 100%; position: absolute; left: 16px; top: 35px;
            " @click="closeCart"><i class="fal fa-arrow-left"></i></span>
            <h4 style="
            font-size: 26px;
                line-height: 34px;
                color: #000;
                letter-spacing: 0.31px;
                font-weight: 500;
                margin-bottom: 5px;
            ">{{ defaultCartLanguage.cart }}</h4>
            <h5 style="margin-bottom: 25px" v-if="cartRestaurant">{{ cartRestaurant.name }}</h5>
            <div style="overflow-x: hidden;overflow-y: scroll; width: 100%">
                <template v-if="cart && cart.length">
                    <div style="border-top: 1px solid #f2f2f2; padding: 10px 0; display: flex; justify-content: space-between; align-items: flex-start; width: 100%;" v-for="item in cart" @click="setPreviewableCartItem(item.item)">
                        <div style="color: #01AD83; width: 30px; font-weight: bold;">{{ item.qty }}x</div>
                        <div style="flex-grow: 1">{{ findValueFromCode(item.item, 'title', language, defaultLanguage, false) }}</div>
                        <div>{{ (item.qty * item.price).toFixed(2) }} €</div>
                    </div>
                    <hr>
                    <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%; opacity: .50" >
                        <div>{{ defaultCartLanguage.subtotal }}</div>
                        <div>{{ (cartTotal).toFixed(2) }} €</div>
                    </div>
                    <template v-if="(cartRestaurant && (cartRestaurant.business_model == 'room_service' || cartRestaurant.business_model == 'delivery')) || isShop">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%; opacity: .50" v-if="charges.room_service_fee_charge > 0">
                            <div>{{ defaultCartLanguage.room_service_fee_charges }}</div>
                            <div>{{ ((charges.room_service_fee_type == 'fixed') ? (charges.room_service_fee_charge / 100) : (cartTotal * charges.room_service_fee_charge / 10000)).toFixed(2) }} €</div>
                        </div>
                    </template>
                    <template v-if="(cartRestaurant && cartRestaurant.business_model == 'delivery') || isShop">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%; opacity: .50" v-if="charges.delivery_fee_charge > 0">
                            <div>{{ defaultCartLanguage.delivery_fee_charges }}</div>
                            <div>{{ ((charges.delivery_fee_type == 'fixed') ? (charges.delivery_fee_charge / 100) : (cartTotal * charges.delivery_fee_charge / 10000)).toFixed(2) }} €</div>
                        </div>
                    </template>

                    <ServiceTypeForm :restaurant="cartRestaurant"></ServiceTypeForm>

                    <br>
                    <template v-if="!isShop">
                        <template v-if="canShowNoteForm">
                            <div v-if="showNoteForm">
                                <div class="form-group">
                                    <textarea class="form-control" v-model="formNote" :placeholder="defaultCartLanguage.add_note_placeholder"></textarea>
                                </div>
                                <button style="display: flex; justify-content: center; align-items: center; font-weight: bold; width: calc(100vw - 40px); height: 40px; color: #01AD83; background: white; border: 1px solid #f2f2f2; border-radius: 4px" @click.prevent="setCartNote(formNote); showNoteForm = false; formNote = ''">{{defaultCartLanguage.save_note_button }}</button>
                            </div>
                            <div v-else-if="!showNoteForm && cartNote">
                                <p>{{ cartNote }}</p>
                                <button style="display: flex; justify-content: center; align-items: center; width: calc(100vw - 40px); height: 46px; color: #01AD83; background: white; border: 1px solid #f2f2f2; border-radius: 4px" @click="formNote = cartNote; showNoteForm = true">{{ defaultCartLanguage.edit_note_button }}</button>
                            </div>
                            <div v-else>
                                <button style="display: flex; justify-content: center; align-items: center; width: calc(100vw - 40px); height: 46px; color: #01AD83; background: white; border: 1px solid #f2f2f2; border-radius: 4px" @click="showNoteForm = true">{{ defaultCartLanguage.add_note_button }}</button>
                            </div>
                        </template>
                    </template>
                    <div>
                        <div class="row">
                            <div class="col-4">{{ defaultCartLanguage.total }}</div>
                            <div class="col-4"></div>
                            <div class="col-4 text-right">€{{ (cartFullTotal).toFixed(2) }}</div>
                        </div>
                        <div class="row" v-if="emailMandatoryOnOrder" style="margin-top: 10px">
                            <div class="col-12">
                                <div class="form-group" style="width: 100%;">
                                    <input class="form-control text-center" :placeholder="`* ${defaultCartLanguage.confirmation_subheading}`" v-model="localEmail">
                                </div>
                            </div>
                        </div>
                        <div class="row" style="margin-top: 20px" v-if="isShop">
                            <div v-if="emailIsValid" class="col-12"><button class="text-center btn btn-block" @click.prevent="localShowDeliveryDetails()">{{ defaultCartLanguage.add_delivery_details }}</button></div>
                            <div v-else class="col-12"><button class="text-center btn btn-block" style='background-color: #EDEDED!important; color: #908c8c!important'>{{ defaultCartLanguage.add_delivery_details }}</button></div>
                        </div>
                        <template v-else>
                            <div class="row" style="margin-top: 10px">
                                <div class="col-12">
                                    <input type="checkbox" name="terms-accepted" v-model="termsAccepted"> {{ defaultCartLanguage.terms_pt1 }} <a :href="termsLink" target="_blank">{{ defaultCartLanguage.terms_pt2 }}</a>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 10px" v-if="termsAccepted && emailIsValid && amountIsValid">
                                <div class="col-12"><button class="text-center btn btn-block" @click.prevent="localSendOrder()">{{ defaultCartLanguage.send_order_button }}</button></div>
                            </div>
                            <div class="row" style="margin-top: 10px" v-else>
                                <div class="col-12" v-if="!amountIsValid" style="color: red; text-align: center;">{{ defaultCartLanguage.minimum_order_is }} €{{ parseFloat(minimumOrder).toFixed(2) }}</div>
                                <div class="col-12"><button class="text-center btn btn-block" style='background-color: #EDEDED!important; color: #908c8c!important'>{{ defaultCartLanguage.send_order_button }}</button></div>
                            </div>
                        </template>
                    </div>
                </template>
                <div v-else><span><small><em>{{ defaultCartLanguage.cart_is_empty }}</em></small></span></div>
            </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import ServiceTypeForm from './Parts/ServiceType/ServiceTypeForm'
import EventBus from '../EventBus'

export default {
    data() {
        return  {
            canShowNoteForm: false,
            canShowNoteForm: true,
            showNoteForm: false,
            formNote: '',
            localEmail: null,
            termsAccepted: false,
            businessModelFee: 0,
            localServiceTypeForm: {}
        }
    },

    created() {
        //EventBus.$on('businessModelFeeChanged', (businessModelFee) => {
        //    this.businessModelFee = businessModelFee;
        //});

        this.canShowNoteForm = (this.cartRestaurant && this.cartRestaurant.business_model != 'delivery');

        EventBus.$on('serviceTypeFormValueUpdated', (serviceTypeFormItem) => {
            var object = {
                [serviceTypeFormItem.key]: serviceTypeFormItem.value
            };
            this.localServiceTypeForm = _.merge(this.localServiceTypeForm, object);
            this.setServiceTypeForm(this.localServiceTypeForm);
        });
    },

    props: [
        'findValueFromCode', 'language', 'defaultLanguage', 'isShop', 'charges'
    ],

    components: {
        ServiceTypeForm
    },

    computed: {
        ...mapGetters(['cart',
             'cartRestaurant',
             'cartTotal',
             'cartNote',
             'serviceTypeForm',
             'previewableCartItem',
             'defaultCartLanguage',
             'termsLink',
             'emailMandatoryOnOrder',
             'minimumOrder',
             ]),

        emailIsValid() {
            if(!this.emailMandatoryOnOrder) {
                return true
            }

            return this.validateEmail(this.localEmail)
        },

        amountIsValid() {
            return this.cartTotal >= this.minimumOrder
        },

        cartFullTotal() {
            let feeCharge = 0;
            if ((this.cartRestaurant && (this.cartRestaurant.business_model == 'room_service' || this.cartRestaurant.business_model == 'delivery')) || this.isShop) {
                feeCharge += (this.charges.room_service_fee_type == 'percentage' ? this.cartTotal * this.charges.room_service_fee_charge / 10000 : this.charges.room_service_fee_charge / 100);    
            }
            if ((this.cartRestaurant && this.cartRestaurant.business_model == 'delivery') || this.isShop) {
                feeCharge += (this.charges.delivery_fee_type == 'percentage' ? this.cartTotal * this.charges.delivery_fee_charge / 10000 : this.charges.delivery_fee_charge / 100);
            }
            return this.cartTotal + feeCharge;
        }
    },

    methods: {
        ...mapActions(['closeCart', 'setPreviewableCartItem', 'setCartNote', 'setServiceTypeForm', 'sendOrder', 'showDeliveryDetails', 'setCartEmail']),
        validateEmail (email) {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },

        localShowDeliveryDetails () {
            if(this.emailMandatoryOnOrder) {
                this.setCartEmail(this.localEmail)
            }

            this.showDeliveryDetails()
        },

        localSendOrder () {
            this.setCartEmail(this.localEmail);
            this.setServiceTypeForm(this.localServiceTypeForm);
            if(this.emailMandatoryOnOrder) {
                this.sendOrder(true)
            } else {
                this.sendOrder()
            }
        }
    }
}
</script>
